/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CostTypeEnum } from "./CostTypeEnum";
import {
  CostTypeEnumFromJSON,
  CostTypeEnumFromJSONTyped,
  CostTypeEnumToJSON,
  CostTypeEnumToJSONTyped,
} from "./CostTypeEnum";
import type { FloodMonthEnum } from "./FloodMonthEnum";
import {
  FloodMonthEnumFromJSON,
  FloodMonthEnumFromJSONTyped,
  FloodMonthEnumToJSON,
  FloodMonthEnumToJSONTyped,
} from "./FloodMonthEnum";

/**
 *
 * @export
 * @interface DamagePostProcessing
 */
export interface DamagePostProcessing {
  /**
   *
   */
  readonly basicPostProcessing?: number;
  /**
   * 'min', 'avg', or 'max'
   *
   * * `min` - min
   * * `avg` - avg
   * * `max` - max
   */
  costType: CostTypeEnum;
  /**
   *
   */
  floodMonth: FloodMonthEnum;
  /**
   * time in hours
   */
  inundationPeriod: number;
  /**
   * time in hours
   */
  repairTimeInfrastructure: number;
  /**
   * time in hours
   */
  repairTimeBuildings: number;
}

/**
 * Check if a given object implements the DamagePostProcessing interface.
 */
export function instanceOfDamagePostProcessing(value: object): value is DamagePostProcessing {
  if (
    (!("costType" in (value as Record<string, any>)) &&
      !("cost_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["costType"] === undefined &&
      (value as Record<string, any>)["cost_type"] === undefined)
  )
    return false;
  if (
    (!("floodMonth" in (value as Record<string, any>)) &&
      !("flood_month" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["floodMonth"] === undefined &&
      (value as Record<string, any>)["flood_month"] === undefined)
  )
    return false;
  if (
    (!("inundationPeriod" in (value as Record<string, any>)) &&
      !("inundation_period" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["inundationPeriod"] === undefined &&
      (value as Record<string, any>)["inundation_period"] === undefined)
  )
    return false;
  if (
    (!("repairTimeInfrastructure" in (value as Record<string, any>)) &&
      !("repair_time_infrastructure" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["repairTimeInfrastructure"] === undefined &&
      (value as Record<string, any>)["repair_time_infrastructure"] === undefined)
  )
    return false;
  if (
    (!("repairTimeBuildings" in (value as Record<string, any>)) &&
      !("repair_time_buildings" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["repairTimeBuildings"] === undefined &&
      (value as Record<string, any>)["repair_time_buildings"] === undefined)
  )
    return false;
  return true;
}

export function DamagePostProcessingFromJSON(json: any): DamagePostProcessing {
  return DamagePostProcessingFromJSONTyped(json, false);
}

export function DamagePostProcessingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DamagePostProcessing {
  if (json == null) {
    return json;
  }
  return {
    basicPostProcessing:
      json["basic_post_processing"] == null ? undefined : json["basic_post_processing"],
    costType: CostTypeEnumFromJSON(json["cost_type"]),
    floodMonth: FloodMonthEnumFromJSON(json["flood_month"]),
    inundationPeriod: json["inundation_period"],
    repairTimeInfrastructure: json["repair_time_infrastructure"],
    repairTimeBuildings: json["repair_time_buildings"],
  };
}

export function DamagePostProcessingToJSON(json: any): DamagePostProcessing {
  return DamagePostProcessingToJSONTyped(json, false);
}

export function DamagePostProcessingToJSONTyped(
  value?: Omit<DamagePostProcessing, "basicPostProcessing"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    cost_type: CostTypeEnumToJSON(value["costType"]),
    flood_month: FloodMonthEnumToJSON(value["floodMonth"]),
    inundation_period: value["inundationPeriod"],
    repair_time_infrastructure: value["repairTimeInfrastructure"],
    repair_time_buildings: value["repairTimeBuildings"],
  };
}
